class zoomView {

    constructor(config) {

        // Save object instance reference
        let instance = this;

        /**
         * Some older browsers have different event name
         */
        const wheelSupport = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

        // Default configuration
        let defaultConfig = {
            elementClass:      '.zoom-view',
            zoomStep:          0.3,
            maxZoom:           10,
            minZoom:           1,
            animationDuration: 200,
            wheel:             true,
            pan:               true,
            pinch:             true,
            mouse:             true,
            buttons:           true,
            defaultScale:      2,
            zoomInButton:      '.zoom-view-in',
            zoomOutButton:     '.zoom-view-out',
            debug:             false,
            wheelEvent:        wheelSupport,
            doubleClickDelay:  150,
            callbackMethod:    undefined
        };

        this.engine = {
            zoomActive:             false,
            instance:               instance,
            zoomIn:                 undefined,
            zoomOut:                undefined,
            image:                  undefined,
            wrapper:                undefined,
            offset:                 undefined,
            containerHeight:        undefined,
            containerWidth:         undefined,
            elementHeight:          undefined,
            elementWidth:           undefined,
            containerOffsetX:       undefined,
            containerOffsetY:       undefined,
            initialScale:           undefined,
            initialOffsetX:         undefined,
            initialOffsetY:         undefined,
            pointerOffsetX:         undefined,
            pointerOffsetY:         undefined,
            initialPointerOffsetX2: undefined,
            initialPointerOffsetY2: undefined,
            pinchOffsetX:           undefined,
            pinchOffsetY:           undefined,
            pointerOffsetX2:        undefined,
            pointerOffsetY2:        undefined,
            imagetargetOffsetX:     undefined,
            imagetargetOffsetY:     undefined,
            targetPinchDistance:    undefined,
            initialPinchDistance:   undefined,
            scaleDirection:         undefined,
            scaleDifference:        undefined,
            targetScale:            undefined,
            limitOffsetX:           undefined,
            limitOffsetY:           undefined,
            targetOffsetX:          undefined,
            targetOffsetY:          undefined,
            initialPointerOffsetX:  undefined,
            initialPointerOffsetY:  undefined,
            mousemoveCount:         0,
            doubleClickMonitor:     [null],
            lastAction:             undefined,
            touchCount:             0,
            doubleTapMonitor:       [null],
            touchmoveCount:         0,
            capture:                false,
            touchable:              false,
            transformY:             0,
            transformX:             0,
            scale:                  1
        };

        this.constants = {
            _activeClass:    'zoom-view--active',
            _dataScale:      'data-scale',
            _dataTranslateX: 'data-translate-x',
            _dataTranslateY: 'data-translate-y',
            _actions:        {
                scroll:     'SCROLL',
                pinch:      'PINCH',
                pan:        'PAN',
                manualZoom: 'MANUAL_ZOOM'
            },
            _mac:            'Mac',
            _safari:         'safari',
            _chrome:         'chrome',
            _event:          {
                dblTap:   'doubleTapMonitor',
                dblClick: 'doubleClickMonitor'
            },
            _function:       'function'
        };

        //Check if anything passed as config
        //TODO: Handle different types here string, num just in case
        if (config !== undefined) {
            config = Object.keys(config).length ? {
                ...defaultConfig,
                ...config
            } : defaultConfig;
        } else {
            config = defaultConfig;
        }

        // this.defaultConfig = defaultConfig;
        this.config = config;
        this.engine.wrapper = document.querySelector(config.elementClass);
        this.engine.image = this.engine.wrapper.children[0];

        /**
         * Actions
         */

        /* Manual zoom in */
        this.actionZoomIn = function (evt = null, stepDown = false) {
            let temp = undefined;
            if (stepDown) {
                temp = instance.config.zoomStep;
                instance.config.zoomStep = 0.1;
            }

            instance.debugLog('Manual zoom out action', evt);
            // In of manual zoom, continue zooming in center
            if (instance.engine.lastAction !== instance.constants._actions.manualZoom) {
                instance.calculateScreenXY();
            }
            instance.engine.scaleDirection = 1;
            instance.calculateZoom();

            if (stepDown) {
                instance.config.zoomStep = temp;
            }
        };

        /* Manual zoom out */
        this.actionZoomOut = function (evt = null) {
            instance.engine.scaleDirection = -1;
            instance.calculateZoom();
            instance.debugLog('Manual zoom out action', evt);
        };

        /* Scroll actions */
        this.actionScroll = function (wheelEvent) {
            instance.engine.pointerOffsetX = wheelEvent.clientX;
            instance.engine.pointerOffsetY = wheelEvent.clientY;
            instance.engine.scaleDirection = wheelEvent.deltaY < 0 ? 1 : -1;
            instance.calculateZoom();
            instance.debugLog('Scroll action');
        };

        /* Touch start events */
        this.actionTouchStart = function (event) {
            instance.engine.touchable = true;
            event.preventDefault();
            if (event.touches.length > 2) {
                return false;
            }
            instance.calculateSpace();
            instance.engine.initialPointerOffsetX = event.touches[0].clientX;
            instance.engine.initialPointerOffsetY = event.touches[0].clientY;
            instance.engine.touchCount = event.touches.length;
            if (instance.engine.touchCount === 1) {
                if (instance.engine.doubleTapMonitor[0] === null) {
                    instance.tapClickMonitor(event, instance.constants._event.dblTap)
                } else if (instance.engine.doubleTapMonitor[0] === event.target &&
                        instance.engine.touchmoveCount <= 1 &&
                        instance.isWithinRange(
                                instance.engine.initialPointerOffsetX,
                                instance.engine.doubleTapMonitor[1] - 10,
                                instance.engine.doubleTapMonitor[1] + 10) === true &&
                        instance.isWithinRange(
                                instance.engine.initialPointerOffsetY,
                                instance.engine.doubleTapMonitor[2] - 10,
                                instance.engine.doubleTapMonitor[2] + 10) === true) {
                    if (instance.engine.zoomActive === true) {
                        instance.reset();
                    } else {
                        instance.engine.pointerOffsetX = event.touches[0].clientX;
                        instance.engine.pointerOffsetY = event.touches[0].clientY;
                        instance.engine.targetScale = instance.config.defaultScale;
                        instance.engine.scaleDirection = 1;
                        instance.engine.scaleDifference = (instance.config.defaultScale - 1) * instance.engine.scaleDirection;
                        instance.calculateLimitOffsets();
                        if (instance.engine.targetScale <= 1) {
                            instance.engine.targetOffsetX = 0;
                            instance.engine.targetOffsetY = 0;
                        } else {
                            instance.targetOffsetsCalc();
                        }
                        instance.zoomStateActivate();
                        instance.setTransformValuesState(
                                instance.engine.targetOffsetX,
                                instance.engine.targetOffsetY,
                                instance.engine.targetScale
                        );
                        instance.transformImage(
                                instance.engine.image,
                                instance.engine.targetOffsetX,
                                instance.engine.targetOffsetY,
                                instance.engine.targetScale
                        );
                    }
                    instance.engine.doubleTapMonitor = [null];
                    return false;
                }
                instance.setInitialOffsets();
            } else if (instance.engine.touchCount === 2) {
                instance.setInitialOffsets();
                instance.engine.initialPointerOffsetX2 = event.touches[1].clientX;
                instance.engine.initialPointerOffsetY2 = event.touches[1].clientY;
                instance.engine.pinchOffsetX = (instance.engine.initialPointerOffsetX + instance.engine.initialPointerOffsetX2) / 2;
                instance.engine.pinchOffsetY = (instance.engine.initialPointerOffsetY + instance.engine.initialPointerOffsetY2) / 2;
                instance.engine.initialPinchDistance = Math.sqrt(
                        ((instance.engine.initialPointerOffsetX - instance.engine.initialPointerOffsetX2)
                                * (instance.engine.initialPointerOffsetX - instance.engine.initialPointerOffsetX2))
                        + ((instance.engine.initialPointerOffsetY - instance.engine.initialPointerOffsetY2)
                        * (instance.engine.initialPointerOffsetY - instance.engine.initialPointerOffsetY2)));
            }
            instance.engine.touchmoveCount = 0;
            instance.engine.capture = true;
            instance.debugLog('Touch Start event');
        }

        this.actionTouchMove = function (event) {
            event.preventDefault();
            if (instance.engine.capture === false) {
                return false;
            }
            instance.debugLog('Touch move event');
            instance.engine.pointerOffsetX = event.touches[0].clientX;
            instance.engine.pointerOffsetY = event.touches[0].clientY;
            instance.engine.touchCount = event.touches.length;
            instance.engine.touchmoveCount++;

            if (instance.engine.touchCount > 1) {
                instance.engine.pointerOffsetX2 = event.touches[1].clientX;
                instance.engine.pointerOffsetY2 = event.touches[1].clientY;
                instance.engine.targetPinchDistance = Math.sqrt(
                        ((instance.engine.pointerOffsetX - instance.engine.pointerOffsetX2) * (instance.engine.pointerOffsetX
                                - instance.engine.pointerOffsetX2)) + ((instance.engine.pointerOffsetY - instance.engine.pointerOffsetY2)
                        * (instance.engine.pointerOffsetY - instance.engine.pointerOffsetY2)));
                if (instance.engine.initialPinchDistance === null) {
                    instance.engine.initialPinchDistance = instance.engine.targetPinchDistance;
                }
                if (Math.abs(instance.engine.initialPinchDistance - instance.engine.targetPinchDistance) >= 1) {

                    instance.engine.targetScale = instance.minMax(
                            instance.engine.targetPinchDistance / instance.engine.initialPinchDistance * instance.engine.initialScale,
                            instance.config.minZoom,
                            instance.config.maxZoom
                    );
                    instance.calculateLimitOffsets();
                    instance.engine.scaleDifference = instance.engine.targetScale - instance.engine.initialScale;
                    instance.engine.targetOffsetX =
                            (instance.engine.elementWidth * instance.engine.targetScale) <= instance.engine.containerWidth ? 0
                                    : instance.minMax(
                                    instance.engine.initialOffsetX - ((((((instance.engine.pinchOffsetX - instance.engine.containerOffsetX)
                                    - (instance.engine.containerWidth / 2)) - instance.engine.initialOffsetX) / (instance.engine.targetScale
                                    - instance.engine.scaleDifference))) * instance.engine.scaleDifference),
                                    instance.engine.limitOffsetX * (-1), instance.engine.limitOffsetX);
                    instance.engine.targetOffsetY =
                            (instance.engine.elementHeight * instance.engine.targetScale) <= instance.engine.containerHeight ? 0
                                    : instance.minMax(
                                    instance.engine.initialOffsetY - ((((((instance.engine.pinchOffsetY - instance.engine.containerOffsetY)
                                    - (instance.engine.containerHeight / 2)) - instance.engine.initialOffsetY)
                                    / (instance.engine.targetScale - instance.engine.scaleDifference))) * instance.engine.scaleDifference),
                                    instance.engine.limitOffsetY * (-1), instance.engine.limitOffsetY);

                    if (instance.engine.targetScale > 1) {
                        instance.zoomStateActivate();
                    } else {
                        instance.reset();
                    }

                    instance.transformImage(
                            instance.engine.image,
                            instance.engine.targetOffsetX,
                            instance.engine.targetOffsetY,
                            instance.engine.targetScale
                    );

                    instance.engine.initialPinchDistance = instance.engine.targetPinchDistance;
                    instance.engine.initialScale = instance.engine.targetScale;
                    instance.engine.initialOffsetX = instance.engine.targetOffsetX;
                    instance.engine.initialOffsetY = instance.engine.targetOffsetY;
                }

            } else {
                instance.touchMoveMouseMoveCalc();
                instance.setPointerOffsetsToInitial();
                instance.setTransformValuesState(
                        instance.engine.targetOffsetX,
                        instance.engine.targetOffsetY,
                        instance.engine.initialScale
                );
                instance.transformImage(
                        instance.engine.image,
                        instance.engine.targetOffsetX,
                        instance.engine.targetOffsetY,
                        instance.engine.targetScale
                );
            }
            instance.debugLog(`Touch move`);
        }

        this.actionTouchEnd = function (event) {
            instance.debugLog('Touch end actions dispatched');
            instance.engine.touchCount = event.touches.length;
            if (instance.engine.capture === false) {
                return false;
            }

            if (instance.engine.touchCount === 0) /* No touch */ {
                instance.setTransformValuesState(
                        instance.engine.targetOffsetX,
                        instance.engine.targetOffsetY,
                        instance.engine.initialScale
                );
                instance.engine.initialPinchDistance = null;
                instance.engine.capture = false;
            } else if (instance.engine.touchCount === 1) /* Single touch */ {
                instance.engine.initialPointerOffsetX = event.touches[0].clientX;
                instance.engine.initialPointerOffsetY = event.touches[0].clientY;
            } else if (instance.engine.touchCount > 1) /* Pinch */ {
                instance.engine.initialPinchDistance = null;
            }
            instance.debugLog(`Touch end`);
        }

        this.actionMouseDown = function (event) {
            event.preventDefault();
            if (instance.engine.touchable === true || event.which !== 1) {
                return false;
            }
            instance.debugLog(`Mouse down`);
            /* Initialize helpers */
            instance.engine.initialPointerOffsetX = event.clientX;
            instance.engine.initialPointerOffsetY = event.clientY;
            /* Doubleclick */
            if (instance.engine.doubleClickMonitor[0] === null) {
                instance.tapClickMonitor(event, instance.constants._event.dblClick);
            } else if (instance.engine.doubleClickMonitor[0] === event.target &&
                    instance.engine.mousemoveCount <= 5 &&
                    instance.isWithinRange(
                            instance.engine.initialPointerOffsetX,
                            instance.engine.doubleClickMonitor[1] - 10,
                            instance.engine.doubleClickMonitor[1] + 10) === true &&
                    instance.isWithinRange(
                            instance.engine.initialPointerOffsetY,
                            instance.engine.doubleClickMonitor[2] - 10,
                            instance.engine.doubleClickMonitor[2] + 10) === true) {
                if (instance.engine.zoomActive === true) {
                    instance.reset();
                } else {
                    instance.engine.pointerOffsetX = event.clientX;
                    instance.engine.pointerOffsetY = event.clientY;
                    instance.engine.targetScale = instance.config.defaultScale;
                    instance.engine.scaleDirection = 1;
                    instance.engine.scaleDifference = (instance.config.defaultScale - 1) * instance.engine.scaleDirection;
                    instance.calculateLimitOffsets();
                    if (instance.engine.targetScale <= 1) {
                        instance.engine.targetOffsetX = 0;
                        instance.engine.targetOffsetY = 0;
                    } else {
                        instance.targetOffsetsCalc();
                    }
                    instance.zoomStateActivate(true);
                    instance.setTransformValuesState(
                            instance.engine.targetOffsetX,
                            instance.engine.targetOffsetY,
                            instance.engine.targetScale
                    );
                    instance.transformImage(
                            instance.engine.image,
                            instance.engine.targetOffsetX,
                            instance.engine.targetOffsetY,
                            instance.config.defaultScale
                    );
                }
                instance.engine.doubleClickMonitor = [null];
                return false;
            }
            instance.calculateSpace();
            instance.setInitialOffsets();
            instance.engine.mousemoveCount = 0;
            /* Set capture */
            instance.engine.capture = true;
        }

        this.actionMouseMove = function (event) {
            if (instance.engine.touchable === true || instance.engine.capture === false) {
                return false;
            }
            instance.debugLog(`Mouse move`);
            /* Initialize helpers */
            instance.engine.pointerOffsetX = event.clientX;
            instance.engine.pointerOffsetY = event.clientY;
            instance.engine.targetScale = instance.engine.initialScale;
            instance.calculateLimitOffsets();
            instance.touchMoveMouseMoveCalc();
            instance.engine.mousemoveCount++;
            instance.setPointerOffsetsToInitial();
            instance.setTransformValuesState(
                    instance.engine.targetOffsetX,
                    instance.engine.targetOffsetY,
                    instance.engine.targetScale
            );
            instance.transformImage(
                    instance.engine.image,
                    instance.engine.targetOffsetX,
                    instance.engine.targetOffsetY,
                    instance.engine.targetScale
            );
        }

        this.actionMouseUp = function () {
            if (instance.engine.touchable === true || instance.engine.capture === false) {
                return false;
            }
            instance.debugLog(`Mouse up`);

            /* Unset capture */
            instance.engine.capture = false;
        }
        /**
         * Helper methods
         */
        this.minMax = function (value, min, max) {
            if (value < min) {
                value = min;
            } else if (value > max) {
                value = max;
            }

            return value;
        };

        this.getLimitOffset = function (elementDimension, containerDimension, targetScale) {
            return ((elementDimension * targetScale) - containerDimension) / 2;
        };

        this.isWithinRange = function (value, min, max) {
            return value >= min && value <= max;
        }

        this.calculateSpace = function () {
            this.engine.offset = this.engine.wrapper.getBoundingClientRect();
            this.engine.containerHeight = this.engine.wrapper.clientHeight;
            this.engine.containerWidth = this.engine.wrapper.clientWidth;
            this.engine.elementHeight = this.engine.image.clientHeight;
            this.engine.elementWidth = this.engine.image.clientWidth;
            this.engine.containerOffsetX = this.engine.offset.left;
            this.engine.containerOffsetY = this.engine.offset.top;
            this.engine.initialScale = this.minMax(
                    parseFloat(this.engine.scale),
                    this.config.minZoom,
                    this.config.maxZoom
            );
        }

        this.setTransformValuesState = function (transformX, transformY, scale) {
            this.engine.transformY = transformY;
            this.engine.transformX = transformX;
            this.engine.scale = scale;
        }

        this.calculateLimitOffsets = function () {
            this.engine.limitOffsetX = this.getLimitOffset(
                    this.engine.elementWidth,
                    this.engine.containerWidth,
                    this.engine.targetScale
            );
            this.engine.limitOffsetY = this.getLimitOffset(
                    this.engine.elementHeight,
                    this.engine.containerHeight,
                    this.engine.targetScale
            );
        }

        this.setInitialOffsets = function () {
            this.engine.initialOffsetX = parseFloat(this.engine.transformX);
            this.engine.initialOffsetY = parseFloat(this.engine.transformY);
        }

        this.setPointerOffsetsToInitial = function () {
            if (Math.abs(this.engine.targetOffsetX) === Math.abs(this.engine.limitOffsetX)) {
                this.engine.initialOffsetX = this.engine.targetOffsetX;
                this.engine.initialPointerOffsetX = this.engine.pointerOffsetX;
            }
            if (Math.abs(this.engine.targetOffsetY) === Math.abs(this.engine.limitOffsetY)) {
                this.engine.initialOffsetY = this.engine.targetOffsetY;
                this.engine.initialPointerOffsetY = this.engine.pointerOffsetY;
            }
        }

        this.tapClickMonitor = function (event, eventMonitorType) {
            const instance = this;
            instance.engine[eventMonitorType][0] = event.target;
            instance.engine[eventMonitorType][1] = instance.engine.initialPointerOffsetX;
            instance.engine[eventMonitorType][2] = instance.engine.initialPointerOffsetY;
            setTimeout(function () {
                instance.engine[eventMonitorType] = [null];
            }, instance.config.doubleClickDelay);
        }

        this.touchMoveMouseMoveCalc = function () {
            this.engine.targetScale = this.engine.initialScale;
            this.calculateLimitOffsets();
            this.engine.targetOffsetX = (this.engine.elementWidth * this.engine.targetScale) <= this.engine.containerWidth ? 0
                    : this.minMax(
                            this.engine.pointerOffsetX - (this.engine.initialPointerOffsetX - this.engine.initialOffsetX),
                            this.engine.limitOffsetX * (-1),
                            this.engine.limitOffsetX
                    );
            this.engine.targetOffsetY = (this.engine.elementHeight * this.engine.targetScale) <= this.engine.containerHeight ? 0
                    : this.minMax(
                            this.engine.pointerOffsetY - (this.engine.initialPointerOffsetY - this.engine.initialOffsetY),
                            this.engine.limitOffsetY * (-1),
                            this.engine.limitOffsetY
                    );
        }

        this.targetOffsetsCalc = function () {
            this.engine.targetOffsetX =
                    (this.engine.elementWidth * this.engine.targetScale) <= this.engine.containerWidth ? 0 : this.minMax(
                            this.engine.initialOffsetX - ((((((this.engine.pointerOffsetX
                            - this.engine.containerOffsetX) - (this.engine.containerWidth / 2))
                            - this.engine.initialOffsetX)
                            / (this.engine.targetScale - this.engine.scaleDifference)))
                            * this.engine.scaleDifference), this.engine.limitOffsetX * (-1),
                            this.engine.limitOffsetX);
            this.engine.targetOffsetY =
                    (this.engine.elementHeight * this.engine.targetScale) <= this.engine.containerHeight ? 0 : this.minMax(
                            this.engine.initialOffsetY - ((((((this.engine.pointerOffsetY
                            - this.engine.containerOffsetY) - (this.engine.containerHeight / 2))
                            - this.engine.initialOffsetY)
                            / (this.engine.targetScale - this.engine.scaleDifference)))
                            * this.engine.scaleDifference), this.engine.limitOffsetY * (-1),
                            this.engine.limitOffsetY);
        }

        /**
         * Calculate zoom - main method that does final calculations and call the transofrmation over the image object.
         */
        this.calculateZoom = function () {
            instance.calculateSpace();
            instance.setInitialOffsets()
            instance.engine.scaleDifference = instance.config.zoomStep * instance.engine.scaleDirection;
            instance.engine.targetScale = instance.engine.initialScale + instance.engine.scaleDifference;
            /* Prevent scale overflow */
            if (instance.engine.targetScale < instance.config.minZoom || instance.engine.targetScale > instance.config.maxZoom) {
                return false;
            }
            instance.calculateLimitOffsets();
            if (instance.engine.targetScale <= 1) {
                instance.engine.targetOffsetX = 0;
                instance.engine.targetOffsetY = 0;
            } else {
                instance.engine.targetOffsetX =
                        (instance.engine.elementWidth * instance.engine.targetScale) <= instance.engine.containerWidth ? 0
                                : instance.minMax(
                                instance.engine.initialOffsetX - ((((((instance.engine.pointerOffsetX - instance.engine.containerOffsetX)
                                - (instance.engine.containerWidth / 2)) - instance.engine.initialOffsetX) / (instance.engine.targetScale
                                - instance.engine.scaleDifference))) * instance.engine.scaleDifference),
                                instance.engine.limitOffsetX * (-1),
                                instance.engine.limitOffsetX
                                );
                instance.engine.targetOffsetY =
                        (instance.engine.elementHeight * instance.engine.targetScale) <= instance.engine.containerHeight ? 0
                                : instance.minMax(
                                instance.engine.initialOffsetY - ((((((instance.engine.pointerOffsetY - instance.engine.containerOffsetY)
                                - (instance.engine.containerHeight / 2)) - instance.engine.initialOffsetY) / (instance.engine.targetScale
                                - instance.engine.scaleDifference))) * instance.engine.scaleDifference),
                                instance.engine.limitOffsetY * (-1),
                                instance.engine.limitOffsetY
                                );
            }

            instance.engine.targetScale > 1 ? instance.zoomStateActivate() : instance.reset();

            instance.setTransformValuesState(
                    instance.engine.targetOffsetX,
                    instance.engine.targetOffsetY,
                    instance.engine.targetScale
            );
            instance.transformImage(
                    instance.engine.image,
                    instance.engine.targetOffsetX,
                    instance.engine.targetOffsetY,
                    instance.engine.targetScale
            );
            instance.debugLog(`Calculate zoom parameters`);
        };

        /**
         * Set engine values
         */
        this.setEngineValues = () => {
            this.setTransformValuesState(0, 0, 1);
            this.calculateSpace();
            this.setInitialOffsets();
            this.calculateLimitOffsets();
            this.config.defaultScale = this.config.minZoom;
            this.engine.targetScale = this.config.defaultScale;
            this.engine.targetOffsetX = (this.engine.elementWidth * this.engine.targetScale) > this.engine.containerWidth ?
                    this.minMax(
                            this.engine.initialOffsetX,
                            this.engine.limitOffsetX * (-1),
                            this.engine.limitOffsetX
                    ) : 0;
            this.engine.targetOffsetY = (this.engine.elementHeight * this.engine.targetScale) > this.engine.containerHeight ?
                    this.minMax(
                            this.engine.initialOffsetY,
                            this.engine.limitOffsetY * (-1),
                            this.engine.limitOffsetY
                    ) : 0;
            this.calculateScreenXY();
            this.debugLog(`Set engine values`);
        };

        /**
         * Apply zoom transformation to the element
         */
        this.transformImage = function ($element, targetOffsetX, targetOffsetY, targetScale) {

            if (this.engine.initialScale !== targetScale && instance.engine.touchCount === 0) {
                this.smoothTransition();
            }

            $element.style.transform = `translate(${targetOffsetX}px, ${targetOffsetY}px) scale(${targetScale})`;
        };

        /**
         * Screen calculation for scroll
         */
        this.calculateScreenXY = function () {
            this.engine.pointerOffsetX = Math.floor(window.innerWidth / 2);
            this.engine.pointerOffsetY = Math.floor(window.innerHeight / 2);
        };

        /**
         * Debug logger
         */
        this.debugLog = function (message = null, event = null) {
            if (this.config.debug) {
                console.log({
                    instance: instance,
                    message:  message,
                    event:    event
                });
            }
        };

        /**
         * Templating section
         */
        this.clickEventTemplate = new MouseEvent('click', {
            bubbles:    true,
            cancelable: true,
            view:       window
        });

        /**
         * Zoom active status control
         */
        this.zoomStateActivate = function (state = true) {
            if (state) {
                this.engine.zoomActive = true;
                this.engine.wrapper.classList.add(this.constants._activeClass);
                instance.debugLog('Changing zoom to active state. Scale > 0');
            } else {
                this.engine.zoomActive = false;
                this.engine.wrapper.classList.remove(this.constants._activeClass);
                instance.debugLog('Changing zoom to inactive state. Scale is 1 or less');
            }
        }

        /**
         * Zoom in animation - smoothening
         */
        this.smoothTransition = function () {
            this.debugLog('Smoothening...');

            const transition = `all ${this.config.animationDuration}ms`;
            this.engine.image.style.transition = transition;
            this.engine.image.style.WebkitTransition = transition;
            this.engine.image.style.MozTransition = transition;

            setTimeout(() => {
                this.engine.image.style.transition = null;
                this.engine.image.style.WebkitTransition = null;
                this.engine.image.style.MozTransition = null;
                this.debugLog('Smoothening done.');
            }, this.config.animationDuration)
        }
    }

    init() {
        this.debugLog(`Initialization`);

        /**
         * Set engine values/correct calculation when called
         */
        this.setEngineValues();

        // If we want button controls to be auto activated
        if (this.config.buttons) {
            this.engine.zoomIn = document.querySelector(this.config.zoomInButton);
            this.engine.zoomOut = document.querySelector(this.config.zoomOutButton);
            if (this.engine.zoomIn) {
                this.engine.zoomIn.addEventListener('click', this.actionZoomIn);
            }
            if (this.engine.zoomIn) {
                this.engine.zoomOut.addEventListener('click', this.actionZoomOut);
            }
            this.debugLog(`Binded +/- button event`);
        }

        if (this.config.wheel) {
            this.engine.wrapper.addEventListener(this.config.wheelEvent, this.actionScroll);
            this.debugLog(`Binded wheel event`);
        }

        if (this.config.pinch) {
            this.engine.wrapper.addEventListener('touchstart', this.actionTouchStart);
            this.engine.wrapper.addEventListener('touchmove', this.actionTouchMove, {passive: false});
            this.engine.wrapper.addEventListener('touchend', this.actionTouchEnd);
            this.debugLog(`Binded touch start, touch move and touch end events`);
        }

        if (this.config.mouse) {
            this.engine.wrapper.addEventListener('mousedown', this.actionMouseDown);
            this.engine.wrapper.addEventListener('mousemove', this.actionMouseMove);
            this.engine.wrapper.addEventListener('mouseup', this.actionMouseUp);
            this.debugLog(`Binded mousedown, mousemove and mouseup events`);
        }
    }

    reset() {

        this.setEngineValues();
        this.setTransformValuesState(0, 0, 1);
        this.transformImage(
                this.engine.image,
                this.engine.targetOffsetX,
                this.engine.targetOffsetY,
                this.engine.targetScale
        );

        if (this.config.callbackMethod &&
                typeof this.config.callbackMethod === this.constants._function &&
                this.engine.zoomActive) {
            this.config.callbackMethod();
        }

        this.zoomStateActivate(false);

        this.debugLog(`Reset settings`);
    }

    manualZoomIn() {
        this.engine.zoomIn.dispatchEvent(this.clickEventTemplate);
        this.engine.lastAction = this.constants._actions.manualZoom;
        this.debugLog(`Zoom out call`);
    }

    manualZoomOut() {
        this.engine.zoomOut.dispatchEvent(this.clickEventTemplate);
        this.engine.lastAction = this.constants._actions.manualZoom;
        this.debugLog(`Zoom in proto call`);
    }

    destroy() {
        this.debugLog(`Unbinding all events`);
        this.reset();
        this.engine.zoomIn.removeEventListener('click', this.actionZoomIn);
        this.engine.zoomOut.removeEventListener('click', this.actionZoomOut);
        // Wheel event
        this.engine.wrapper.removeEventListener(this.config.wheelEvent, this.actionScroll);
        // Touch events
        this.engine.wrapper.removeEventListener('touchstart', this.actionTouchStart);
        this.engine.wrapper.removeEventListener('touchmove', this.actionTouchMove, {passive: false});
        this.engine.wrapper.removeEventListener('touchend', this.actionTouchEnd);
        // Mouse events
        this.engine.wrapper.removeEventListener('mousedown', this.actionMouseDown);
        this.engine.wrapper.removeEventListener('mousemove', this.actionMouseMove);
        this.engine.wrapper.removeEventListener('mouseup', this.actionMouseUp);
        this.debugLog('Destroy done');
    }
}

export default zoomView;